import { PaginationParams } from '@/lib/types';
import { api, ApiResponse } from './api';

/**
 * External Patients service
 *
 * Patients who are not primary to the active clinic but have been granted
 * cross-clinic access via the `external_patients` table (e.g. Nimbus partner
 * clinic visibility for guided HRT/TRT orders).
 *
 * Backend: POST /external-patients/list
 */
export const externalPatientService = {
  getExternalPatients: (params?: PaginationParams): Promise<ApiResponse<any>> => {
    const payload = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
      genders: params?.filter?.genders || [],
      statuses: params?.filter?.statuses || [],
      dobFrom: params?.filter?.dobFrom,
      dobTo: params?.filter?.dobTo,
    };
    return api.post<any>('/external-patients/list', payload);
  },
};
